export var RoleEnum = {
    PUBLISHER_ADMIN: "PublisherAdmin",
    AGENCY_WORKER: "AgencyWorker",
    PUBLISHER_GUARANTOR: "PublisherGuarantor",
    SUPERUSER: "Superuser",
    LOGGED_USER: "LoggedUser",
};
